import styled from 'styled-components';
import { ReactComponent as DuplicateSVG } from 'Images/icon-show-duplicates.svg';

const DuplicateIcon = styled(DuplicateSVG)`
     & path{
        fill: ${({ color }) => (color || '#7a7e8f')};
    }
`;
DuplicateIcon.dipslayName = 'DuplicateIcon';

export default DuplicateIcon;
